<template>
    <div>
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
            <div class="header-buttons">
                <button
                    v-if="
                        (!isUpdate && perm_perfilacessotelas.create) ||
                        (isUpdate && perm_perfilacessotelas.update)
                    "
                    @click="save"
                    :disabled="isSaving"
                    class="save-btn"
                    type="button"
                >
                    {{ $t('salvar') }}
                    <button-loader :isSaving="isSaving" />
                </button>
            </div>
        </div>

        <div class="page-container form-columns-fit">
            <div class="columns is-flex-wrap">
                <div class="column is-9">
                    <v-input
                        :id="generateId(1)"
                        ref="nomeInput"
                        title="nome"
                        v-model="nome"
                        placeholder="placeholder-preencha"
                        msg="msg-campo-obrigatorio"
                        :maxlength="255"
                        :invalid="!(nome && nome != '')"
                        :disabled="isSaving"
                        uppercase
                        :required="true"
                    />
                </div>
                <div class="column is-3">
                    <vss-select
                        :id="generateId(2)"
                        ref="situacaoSelect"
                        label="label"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        :title="'situacao'"
                        :disabled="isSaving"
                        mlLabels
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Message from '@/models/Message.js';

export default {
    components: {
        Message,
    },
    props: {
        isUpdate: {
            type: Boolean,
            default: false,
        },
        perm_perfilacessotelas: {
            type: Object,
            default: () => {},
        },
        perfil: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            situacaoSelect: [
                { id: 1, label: 'ativo' },
                { id: 0, label: 'bloqueado' },
            ],
            situacaoSelected: { id: 1, label: 'ativo' },
            nome: null,
            admin: false,
            idperfilacesso: null,
            isSaving: false,
        };
    },
    created() {
        if (this.perfil.nome) {
            this.idperfilacesso = this.perfil.idperfilacesso;
            this.nome = this.perfil.nome;
            this.admin = this.perfil.admin;
            this.situacaoSelected = this.situacaoSelect[this.perfil.situacao == 1 ? 0 : 1];
        }
    },

    methods: {
        generateId(numberId) {
            return this.$route.name + '-geral-' + numberId;
        },
        save() {
            if (!this.nome || !this.nome.trim()) {
                this.$refs.nomeInput.focusedOut = true;
                this.$root.showMessage('alert', 'obrigatorio-nome');
            } else {
                this.$store.commit('addLoader');
                this.isSaving = true;
                let perfil = {
                    idperfilacesso: this.idperfilacesso,
                    nome: this.nome,
                    admin: this.admin,
                    situacao: this.situacaoSelected.id,
                };
                this.$axios
                    .post('config/access-profile', perfil)
                    .then((response) => {
                        if (response.data.content) {
                            // Mudar para alerta padrão, quando o mesmo for criado
                            let msg = this.isUpdate ? 'msg-perfil-editado' : 'msg-perfil-salvo';
                            this.$root.showMessage('success', msg);
                            if (!this.isUpdate) {
                                this.redirectToEdit(response.data.content.id);
                            }
                        } else {
                            if (this.$t(response.data.message)) {
                                this.$root.showMessage('error', response.data.message);
                            } else {
                                this.$root.showMessage('error', 'msg-problema-realizar-acao');
                            }
                        }
                    })
                    .catch((e) => {
                        this.$root.showMessage('error', 'msg-problema-realizar-acao');
                    })
                    .finally(() => {
                        this.isSaving = false;
                        this.$store.commit('removeLoader');
                    });
            }
        },
        redirectToEdit(id) {
            // caso seja um novo registro redireciona para a edição
            setTimeout(() => {
                this.$router.push({
                    name: 'usuario-acessos-permissoes-edit',
                    params: { id: +id },
                });
            }, 1000);
        },
    },
};
</script>
<style lang="scss" scoped>
.page-container {
    .loading {
        opacity: 0.5;
        pointer-events: none;
    }
}
</style>
